// extracted by mini-css-extract-plugin
export default {"sideTitle":"sideTitle-module--sideTitle--f33cf","fadeIn":"sideTitle-module--fadeIn--4e646"};